export default {

  BNO_NFT: {
    97: '',
    // 56: '0xf85bC8d8B25fF541E99Beb894363c0ac6234435a',
    56: '0x363eB10A2b18b4261A1611DeDcb8CC0daE8D6488',
  },

  BNO_NFT_POOL: {
    97: '',
    // 56: '0x67168566c4E31189762697191Ccbcf25A8264D85',
    56: '0xddB207ea218F3687309f4af6dec2DcE2D6ee534d',
  },


  masterChef: {
    97: '0x1d32c2945C8FDCBc7156c553B7cEa4325a17f4f9',
    // 56: '0x73feaa1eE314F8c655E354234017bE2193C9E24E',
    56: '0xb4fB4145F45Db4b185557F1f93d97DA3c977689a',
  },
  masterChefV2: {
    97: '0x1d32c2945C8FDCBc7156c553B7cEa4325a17f4f9',
    56: '0xBa50D279bb3253bB5493Fa4C6B00391976F7f8f9',
  },
  sousChef: {
    97: '0xd3af5fe61dbaf8f73149bfcfa9fb653ff096029a',
    56: '0x6ab8463a4185b80905e05a9ff80a2d6b714b9e95',
  },
  lotteryV2: {
    97: '0x5790c3534F30437641541a0FA04C992799602998',
    56: '0x2a79e910fdFBb7fE51fE5b7283787aFB62063eaa',
  },
  multiCall: {
    56: '0xfF6FD90A470Aaa0c1B8A54681746b07AcdFedc9B',
    97: '0x8F3273Fb89B075b1645095ABaC6ed17B2d4Bc576',
    // 97: '0x78b3bDb48cC8967C0aEAE77A99e06afcC4266E26',
  },
  pancakeProfile: {
    56: '0xDf4dBf6536201370F95e06A0F8a7a70fE40E388a',
    97: '0x4B683C7E13B6d5D7fd1FeA9530F451954c1A7c8A',
  },
  pancakeRabbits: {
    56: '0xDf7952B35f24aCF7fC0487D01c8d5690a60DBa07',
    97: '0x60935F36e4631F73f0f407e68642144e07aC7f5E',
  },
  bunnyFactory: {
    56: '0xfa249Caa1D16f75fa159F7DFBAc0cC5EaB48CeFf',
    97: '0x707CBF373175fdB601D34eeBF2Cf665d08f01148',
  },
  claimRefund: {
    56: '0xE7e53A7e9E3Cf6b840f167eF69519175c497e149',
    97: '',
  },
  pointCenterIfo: {
    56: '0x3C6919b132462C1FEc572c6300E83191f4F0012a',
    97: '0xd2Ac1B1728Bb1C11ae02AB6e75B76Ae41A2997e3',
  },
  bunnySpecial: {
    56: '0xFee8A195570a18461146F401d6033f5ab3380849',
    97: '0x7b7b1583De1DeB32Ce6605F6deEbF24A0671c17C',
  },
  tradingCompetition: {
    56: '0xd718baa0B1F4f70dcC8458154042120FFE0DEFFA',
    97: '0xC787F45B833721ED3aC46E99b703B3E1E01abb97',
  },
  easterNft: {
    56: '0x23c41D28A239dDCAABd1bb1deF8d057189510066',
    97: '0x24ec6962dbe874F6B67B5C50857565667fA0854F',
  },
  cakeVault: {
    56: '0x7d99032456aB4d72b32c1bd82232411506424363',
    97: '',
  },
  predictions: {
    56: '0x59088D460D23Bbe935b8a08762bb2A8DBEf310F1',
    97: '',
  },
  referrer: {
    56: '0xA473b33D0B34dfDD68e6f4ca405BdCAB407f951b',
    97: '0x94e6BDB29A318AABB458A10CC3f6C8437fBddc0D',
  },
  chainlinkOracle: {
    56: '0xD276fCF34D54A926773c399eBAa772C12ec394aC',
    97: '',
  },
  bunnySpecialCakeVault: {
    56: '0x5B4a770Abe7Eafb2601CA4dF9d73EA99363E60a4',
    97: '',
  },
  bunnySpecialPrediction: {
    56: '0x342c99e9aC24157657095eC69CB04b73257e7A9C',
    97: '',
  },
  bunnySpecialLottery: {
    56: '0x24ED31d31C5868e5a96aA77fdcB890f3511fa0b2',
    97: '0x382cB497110F398F0f152cae82821476AE51c9cF',
  },
  farmAuction: {
    56: '0xb92Ab7c1edcb273AbA24b0656cEb3681654805D2',
    97: '0x3F9602593b4f7C67ab045DB51BbDEa94E40fA9Fe',
  },

  nft: {
    56: '0x9f278be3867CA5e6DDb99ED85C3F035CbA1A02D5',
    97: '0x10f68fC1b9f2A8dc638B10CCF74d5d1054f50771',
  },

  eggShare: {
    56: '0x5C27a4Cce8C4A4093C5e16F1c6b96c8e2f6608c2',
    97: '',
  },

  eggPool: {
    56: '0x50B782155928FA1b66b7c886F5b4EF04ae95fC4D',
    97: '',
  },

  dao:{
    56: '0xA467D3CdC9E805A72ee7cC1d193A6ed233C2C35a',
    97: '',
  },

  nftBox: {
    56: '0xa884dd33F0004bB59984BD9057eaacA1e3F2D2CE',
    97: '0x7E5DF1a58FBD1aCe9f9F0723D51b6abA2bF0f63D',
    // 97: '0xbE4D1Bd260E760F2b51C3E61201f2Ad089Df55BD',
  },

  nftMarket: {
    56: '0xFA885b0ba75E360cb109bB8a76b3E0Ab623f1fCD',
    97: '0xB470d5b44B4d66B9b7A2F5C4F823E8d4E1133b4a',
  },

  nftAuction: {
    56: '0x47ace1D5161F4e6014FeC8cCAf1EfD4526cA2E70',
    97: '0x7b8D2db2f9112D178e2f70EbEd4327aFBe43198C',
  },
  miner5xAddress: {
    56: '0xEc3eF30999d1e553f1e3A36e5bf42155Cb753eD1',
    97: '',
  },
  miner5xTimerAddress: {
    56: '0xbFef0a40E061E32eCBd1c91AbCC74B416c5D72Be',
    97: '',
  }
}
